import {IntlShape} from 'react-intl';
import sdk from '@/sdk';
import toast, {ToastType} from '@/components/Toast';
import {Repository, SinglePersonData} from '@/interface';
import {isPersonal} from '@/domains/space/Repository/Utils/fixRepositoryNameWithPersonal';
import {concatImgSrc} from '@/utils/avatarUtils';

// eslint-disable-next-line max-params
export async function shareToRuLiu(
    users: SinglePersonData[],
    repository?: Repository,
    docGuid?: string,
    intl?: IntlShape,
    roleName?: string | boolean,
    content?: string,
    editionUrlId?: string
) {
    const isUserAvatar = isPersonal(repository) && repository?.userGuid;
    const logoSrc = isUserAvatar
        ? concatImgSrc(repository?.userGuid)
        : concatImgSrc('',
            repository?.spaceGuid,
            repository?.groupGuid,
            repository?.repositoryGuid,
            Date.now()
        );
    try {
        const url = window.location.href?.split('?')[0]; // 避免query参数影响(比如ku享场景影响)，只分享最原始的链接
        await sdk.as.share({
            url: content ?? url, // content像是历史逻辑，目前已经没传值进来了
            users: users,
            spaceGuid: repository?.spaceGuid,
            repositoryGuid: repository?.repositoryGuid,
            groupGuid: repository?.groupGuid,
            docGuid: docGuid,
            thumb: logoSrc,
            roleName: roleName || '',
            editionUrlId: editionUrlId || '',
        });
        toast({
            type: ToastType.Success,
            content: intl?.formatMessage({id: 'toastShareSuccess'}),
        });
        return true;

    } catch (error) {
        toast({
            type: ToastType.Error,
            content: intl?.formatMessage({id: 'toastShareFailed'}),
        });
        console.error(error);
        return false;
    }
}
